import { apiInstanceFetch } from "../../../util/api";
import axios from "axios";
import * as ActionType from "./shippingMethod.type";
import { setToast } from "../../../util/toast";

export const getShippingMethod = () => (dispatch) => {
  apiInstanceFetch
    .get(`shippingMethod/get`)
    .then((res) => {
      dispatch({ type: ActionType.GET_SHIPPING_METHOD, payload: res.data });
    })
    .catch((error) => {
      console.log(error);
    });
};

export const createShippingMethod = (data) => (dispatch) => {
  axios
    .post(`shippingMethod/create`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_SHIPPING_METHOD,
          payload: res.data.data,
        });
        setToast("success", "Shipping method created successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const updateShippingMethod = (data, id) => (dispatch) => {
  axios
    .patch(`shippingMethod/update?shippingMethodId=${id}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SHIPPING_METHOD,
          payload: { data: res.data.data, id },
        });
        setToast("success", "Shipping method updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const deleteShippingMethod = (id) => (dispatch) => {
  axios
    .delete(`shippingMethod/delete?shippingMethodId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_SHIPPING_METHOD,
          payload: id,
        });
        setToast("success", "Shipping method deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};
